import React from "react";

const RefreshIcon = () => {
	return (
		<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
			<mask id="mask0_1004_1239" maskUnits="userSpaceOnUse" x="0" y="0" width="15" height="15">
				<rect width="15" height="15" fill="#D9D9D9" />
			</mask>
			<g mask="url(#mask0_1004_1239)">
				<path
					d="M7.53164 12.3438C6.17987 12.3438 5.02945 11.8734 4.08039 10.9327C3.13122 9.99193 2.65664 8.84771 2.65664 7.5V7.01203L1.50039 8.16828L0.841797 7.50969L3.12539 5.22594L5.40898 7.50969L4.75039 8.16828L3.59414 7.01203V7.5C3.59414 8.58573 3.97633 9.50823 4.7407 10.2675C5.50518 11.0267 6.43549 11.4062 7.53164 11.4062C7.79049 11.4062 8.04909 11.378 8.30742 11.3216C8.56586 11.265 8.8181 11.1803 9.06414 11.0673L9.76727 11.7705C9.4155 11.9595 9.05232 12.1023 8.67773 12.1989C8.30305 12.2955 7.92102 12.3438 7.53164 12.3438ZM11.8754 9.77406L9.5918 7.49031L10.2504 6.83172L11.4066 7.98797V7.5C11.4066 6.41427 11.0245 5.49177 10.2601 4.7325C9.4956 3.97333 8.56529 3.59375 7.46914 3.59375C7.21029 3.59375 6.95169 3.62198 6.69336 3.67844C6.43492 3.735 6.18268 3.81974 5.93664 3.93266L5.23352 3.22953C5.58529 3.04047 5.94846 2.89766 6.32305 2.80109C6.69773 2.70453 7.07977 2.65625 7.46914 2.65625C8.82091 2.65625 9.97133 3.12661 10.9204 4.06734C11.8696 5.00807 12.3441 6.15229 12.3441 7.5V7.98797L13.5004 6.83172L14.159 7.49031L11.8754 9.77406Z"
					fill="#0582F8"
				/>
			</g>
		</svg>
	);
};

export default RefreshIcon;
